import {AiChatOpenEditorType, GA4EventName, GA4EventParamName} from '@Libraries/ga-events';
import {trackFakeDoorPostUsedIfNeeded} from '@Libraries/marketing-planner.library';
import {openEditorInNewTab} from '@Components/ai-chat-window/lib/open-editor-tab.library';
import {getTargetSizeCompactForChatImage} from '@Components/ai-chat-window/lib/chat-image-target-size.library';

interface UseOpenChatImageInEditor {
  openPosterInEditor: (hashedId: string) => void;
  openUserDesignInEditor: (posterHashedId: string) => void;
}

const openEditorTab = (path: string, openEditorType: AiChatOpenEditorType): void => {
  trackFakeDoorPostUsedIfNeeded();
  openEditorInNewTab(window.PMW.util.site_url(path));
  window.PMW.gtm.trackGA4CustomEvent(GA4EventName.AICHAT_OPEN_EDITOR, {[GA4EventParamName.TYPE]: openEditorType});
};

const getOpenImageInEditorPath = (hashedId: string): string => {
  const path = `posterbuilder/loadFromAiChatImage/${hashedId}`;
  const targetSizeCompact = getTargetSizeCompactForChatImage(hashedId);

  return targetSizeCompact === null ? path : `${path}?targetSize=${encodeURIComponent(targetSizeCompact)}`;
};

export const useOpenChatImageInEditor = (): UseOpenChatImageInEditor => {
  const openPosterInEditor = (hashedId: string): void => {
    openEditorTab(getOpenImageInEditorPath(hashedId), AiChatOpenEditorType.EDIT_AS_IMAGE);
  };

  const openUserDesignInEditor = (posterHashedId: string): void => {
    openEditorTab(`posterbuilder/load/${posterHashedId}`, AiChatOpenEditorType.EDITABLE_LAYERS);
  };

  return {openPosterInEditor, openUserDesignInEditor};
};
